<template>
	<div id="List">
		<!-- banner -->
		<div v-if='!Nav.lanmu.Logo && !Nav.PColumn || Nav.lanmu.Logo =="http://base.hope55.com" && Nav.PColumn.Logo == "http://base.hope55.com"' class="banner"></div>
		<div v-else-if="Nav.lanmu.Logo==''&& !Nav.PColumn==''" class="banner"></div>
		<div v-else class="banner" :style="{'background-image': 'url('+( Nav.lanmu.Logo ? Nav.lanmu.Logo : Nav.PColumn.Logo )+')'}"></div>
		<!-- 导航 -->
		<div class="navList">
			<div class="topDh">
				<!-- 当前位置 -->
				<address-bar :addressBarData="Nav"></address-bar>
			</div>
			<div class="main w1200">
			  <div v-if="NId" class="newsDetails">
			    <div v-if= "CId == 6600" class="jiaoshiDetail">
			      <div class="jsDetail">
			        <div class="imgs"><img :src="List.Cover" alt=""></div>
			        <h1>{{List.Title}}</h1>
			        <p v-html="List.Details"></p>
			        <!-- {{List.Describe}} -->
			      </div>
			    </div>
			    <div v-else>
			      <div class="details">
			        <template>
			          <p class="title">{{List.Title}}</p>
			          <p class="related_information">
			            <span>发布时间：{{List.ShowTime}}</span>
			            <span>点击：{{List.Press}}次</span>
			          </p>
			        </template>
			      <div class="Details" v-html="List.Details"></div>
			      </div>
			      <div class="listSide">

			        <side-List :sideListData = "sideListData"></side-List>
			      </div>
            <div class="clear"></div>
			    </div>
			  </div>
			  <div v-else id="infoBox">
				   <div v-if="HType==1" v-html="List.Info"  class="singleBox"></div>
				   <component-view v-else :option='{dataList: List ,componentType: currentValue}'></component-view>
			     <!-- 分页 -->
			     <page-box :pageBoxData="List.PageBar" :pageIndex="PageIndex"></page-box>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/css/list.css';
	import addressBar from '@/components/addressBar'
	import pageBox from '@/components/pageBox'
	import componentView from '@/components/componentView'
  import sideList from '@/components/sideList'
	export default{
		name:'list',
		components:{
			addressBar,
			pageBox,
			componentView,
      sideList
		},
		data(){
			return{
			   CId:this.$route.query.CId,
			   NId:this.$route.query.NId,
			   PageIndex:this.$route.query.PageIndex,
			   HType:this.$route.query.HType,
			   Nav:'',
			   item:'',
			   List:[],
			   currentData: '',
       	 currentValue: 'pageBox',
         sideList:[]
			}
		},
		created(){
			this.Nav = this.Curren.SetClassStyle(this.CId);
			this.Nav.List=[];
			this.Nav.lanmu.Fid > 0?this.Nav.List = this.$root.$children['0'].$children['0'].menuListOne.filter(ele=> ele.ID==this.Nav.lanmu.Fid)[0].Children : this.Nav.List.push(this.Nav.lanmu)
      //侧边栏无图新闻
      this.sideListData = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',8);
      //小导航定位
      let strA=$('.PR a').attr('href');
      // if(strA.indexOf(this.CId) != -1){
      //   // console.log(this.CId)router-link-exact-active
      //   // $('.PR a').
      // }
			if( this.$root.$children['0'].$children['0'].menuListOne){
				this.$root.$children['0'].$children['0'].menuListOne.forEach(element => { // 确定菜单点击项
            element.ID == this.CId ? element.On = true : element.On = false
        });
			}
			if(this.NId){//详情
				this.List = this.Base.GetNewsInfoByNid(this.NId);
        // console.log(this.List,"详情")
			}else if(this.HType==1){
				this.List = this.Base.GetSinglePageInfoByCid(this.CId);
			}else if(this.HType==4){
        if(this.CId == 6641) {//下载
        	this.List = this.Base.GetFilesInfoByCid(this.CId,this.PageIndex,'',8);
        	this.currentValue = 'downList';
        }else if(this.CId == 6627){//视频轮播
          this.List = this.Base.GetFilesInfoByCid(this.CId,this.PageIndex,'',10);
          this.currentValue = 'spList';
        }
      }else{
				if(this.CId == 6620 || this.CId == 6630 || this.CId == 6629 || this.CId == 6811 || this.CId == 6623 || this.CId == 6635){ //无图new
					this.List = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',6);
					this.currentValue = 'noImgList';
				}
        else if(this.CId == 6621 || this.CId == 6634){
          this.List = this.Base.GetNewsInfoByCid(this.CId,true,this.PageIndex,'',5);
          this.currentValue = 'ImgList';
        }
        else if(this.CId == 6626){
          this.List = this.Base.GetNewsInfoByCid(this.CId,true,this.PageIndex,'',6);
          this.currentValue = 'jiaoshi';
         // console.log(this.List,'jiaoshi');
        }
        else if(this.CId == 6601){
          this.List = this.Base.GetFilesInfoByCid(this.CId,this.PageIndex,'',6);
          this.currentValue = 'tuwen';
        }else{
          this.List = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',6);
          this.currentValue = 'noImgList';
        }
				 // console.log(this.Nav,'nav');
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/list.vue